import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import QuizDetail from './components/Quiz/QuizDetail';
import HomePage from './pages/Home/HomePage.js';
import Profile from './pages/Profile/Profile.js';
import Header from './components/Header/Header.js';
import Footer from './components/Footer/Footer.js';
import ScrollToTopButton from './components/Tools/ScrollToTopButton.js';
import Quizzes from './pages/Quizzes/Quizzes.js';
import ProtectedRoute from './components/Tools/ProtectedRoute.js';
import EmailConfirmation from './pages/Auth/EmailConfirmation';
import FindPassword from './pages/Auth/FindPassword';
import { Container } from 'react-bootstrap';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import ResetPassword from './pages/Auth/ResetPassword';
import TermsOfService from './components/TermOfService/TermOfService.js';
import ExamPage from './pages/Exam/ExamPage.js';
import Exam from './components/Exam/Exam.js';
import AboutPage from './pages/About/AboutPage.js';
import Logout from './pages/Auth/Logout.js';
import NotFound from './pages/NotFound.js';
import OAuthSuccess from './pages/Auth/OAuthSuccess.js';
import { initAmplitude } from './components/Tools/analytics.js';

// Google Analytics
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
ReactGA.initialize(MEASUREMENT_ID);



const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);

    return null;
};




const App = () => {
    useEffect(() => {
        initAmplitude();
    }, []);

    return (
        <>
            <Header />
            <Container className="flex-grow-1 mt-3">
                <AnalyticsTracker />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/oauth-success" element={<OAuthSuccess />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route path="/confirm/:token" element={<EmailConfirmation />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route element={<ProtectedRoute />}>
                        <Route path="/quizzes" element={<Quizzes />} />
                        <Route path="/quizzes/:id" element={<QuizDetail />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/payment/success" element={<PaymentSuccessPage />} />
                        <Route path="/exam" element={<ExamPage />} />
                        <Route path="/exam/:id" element={<Exam />} />
                    </Route>
                    <Route path='/find-password' element={<FindPassword />} />
                    <Route path='/resetPassword/:token' element={<ResetPassword />} />
                    <Route path='/terms-of-service' element={<TermsOfService />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Container>

            <Footer />
            <ScrollToTopButton />
        </>
    );
};

export default App;